export default __webpack_public_path__ + "static/media/1794all.16fcbe06.JPG";